var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'salesOrder-view', params: { id: _vm.id } },"target":_vm.openInNewTab ? '_blank' : '_self'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }